import { curry } from 'lodash';

import fuzzyscore from '@zapier/common-utils/src/fuzzyscore';

import { NAME } from './constants';

const queryScore = curry((query: string, service: { name: string }) => {
  return -fuzzyscore(query, service[NAME]);
});

export default queryScore;
